import type { FC } from "react";
import styled from "styled-components";
import { logout } from "../../auth";
import { ProfileContent } from "./ProfileContent";

const StyledMobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

type MobileProfileItemProps = {
  onClose: () => void;
};
export const MobileProfileItem: FC<MobileProfileItemProps> = ({ onClose }) => (
  <StyledMobileWrapper>
    <ProfileContent onClose={onClose} logout={() => logout} />
  </StyledMobileWrapper>
);
